import { create } from "zustand";
import { persist } from "zustand/middleware";

interface MerchantStore {
  selectedMerchant: {
    id: string;
    name: string;
  } | null;
  setSelectedMerchant: (merchant: { id: string; name: string } | null) => void;
}

export const useMerchantStore = create<MerchantStore>()(
  persist(
    (set) => ({
      selectedMerchant: null,
      setSelectedMerchant: (merchant) => set({ selectedMerchant: merchant }),
    }),
    {
      name: "merchant-storage",
    }
  )
);